import { Tokens } from '@/assets/tokens'
import styled, { css } from 'styled-components'

export type ImageWidth = {
  $width?: string
}

export const Img = styled.img<ImageWidth>`
  ${({ $width }) => css`
    width: ${$width || '3rem'};
  `}
`

export const DefaultChannelIcon = styled.div<ImageWidth>`
  ${({ $width }) => css`
    width: ${$width || '3rem'};
    height: ${$width || '3rem'};
  `}
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${Tokens.ColorUIPrimary};
`

export const CanalLink = styled.a`
  display: inline-block;
`

export const ChannelNameText = styled.span`
  font-size: 9px;
  font-weight: 600;
  color: #666;
  text-align: center;
  max-width: 70px;
  padding: 2px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
`
